

































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import LocalizadorEndereco from "./LocalizadorEndereco.vue";
import ConsultaVeiculo from "./ConsultaVeiculo.vue";
import { assistencia24hModule } from "@/store/assistencia24h/Assistencia24h";
import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import { TipoServicoEnum } from "@/api/assistencia24h/TipoServicoEnum";
import { QuestionarioTrocaPneuModel } from "@/models/cadastros/assistencia/troca_pneu/QuestionarioTrocaPneuModel";
import { ValidationObserver } from "vee-validate";
import ContatoLocal from "./ContatoLocal.vue";
import { DadosPagamentoServicoModel } from "@/models/cadastros/assistencia/DadosPagamentoServicoModel";
import ServicoSubClienteModel from "@/models/cadastros/assistencia/ServicoSubClienteModel";
import ServicoSubCliente from "./ServicoSubCliente.vue";
import { SimNaoList } from "@/models/cadastros/assistencia/SimNaoModel";
import { SimNaoModel } from "@/models/cadastros/assistencia/SimNaoModel";
import ClienteAdministrativo from "./ClienteAdministrativo.vue";
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";
import { tiposEndereco } from "@/models/cadastros/assistencia/TipoEndereco";
import { estadosList } from "@/models/Estados";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import ValoresClienteAdministrativoModel from "@/models/cadastros/assistencia/ValoresClienteAdministrativoModel";


@Component({
  components: {
    LocalizadorEndereco,
    ConsultaVeiculo,
    ContatoLocal,
    GsModalDialog,
    ServicoSubCliente,
    ClienteAdministrativo,
  },
  beforeRouteEnter: (to, from, next) => {
    window.scrollTo(0, 0);
    next((vm: any) => {
      const vueComponent = vm as QuestionarioTrocaPneu;
      if (from.name === "ConfirmacaoDadosPrecificacao") {
        vueComponent.loadFromStore();
      } else {
        vueComponent.resetStore();
      }
      assistencia24hModule.SET_TIPO_SERVICO(TipoServicoEnum.TROCA_PNEU);
    });
  },
})
export default class QuestionarioTrocaPneu extends Vue {
  $refs!: {
    trocaPneuObserver: InstanceType<typeof ValidationObserver>;
  };
  veiculoDoAssociado = true;
  nomeContatoNoLocal = "";
  telefoneContatoNoLocal = "";
  veiculo: VeiculoModel = {
    placa: "",
    chassi: "",
    marca: "",
    modelo: "",
    anoFabricacao: "",
    anoModelo: "",
    cor: "",
    combustivel: "",
    cilindrada: "",
    tipoVeiculo: { valor: "", texto: "" },
  };
  enderecoSelecionado: LocalidadeModel = new LocalidadeModel();
  veiculoEmLocalFechado = false;
  veiculoEmSubsolo = false;
  loadingData = false;
  exibirCancelar = true;

  messageDialog = false;
  message = "";
  loadingFrota = false;

  showDialog = false;
  dialogMessage = "";
  dialogType = "";
  showDialogFrota = false;
  dialogTitle = "";
  dialogMessageAux = "";
  successDialog = false;
  possuiFerramentaList = SimNaoList;
  possuiFerramenta?: SimNaoModel;
  possuiStepList = SimNaoList;
  possuiStep?: SimNaoModel;
  showDialogStep = false;
  carregadoList = SimNaoList;
  carregado?: SimNaoModel;

  cardForm: DadosPagamentoServicoModel = {
    id: 0,
    bandeira: undefined,
    codigoSeguranca: undefined,
    nomeTitular: undefined,
    numeroCartao: undefined,
    validade: undefined
  };

  isFrota = false;
  enderecoServicoFrota: LocalidadeModel = new LocalidadeModel();
  servicoSubClienteFrota: ServicoSubClienteModel = new ServicoSubClienteModel();
  tiposEnderecos = tiposEndereco;
  estados = estadosList;
  enderecoClienteAdministrativo: LocalidadeModel = new LocalidadeModel();
  clienteAdm = false;
  clienteAdministrativo: ClienteAdministrativoModel = new ClienteAdministrativoModel();
  showDialogAdm = false;
  moneyMaskProperties = moneyMaskProperties;
  valoresAdm: ValoresClienteAdministrativoModel = new ValoresClienteAdministrativoModel();
  valoresPrecificado: ValoresClienteAdministrativoModel = new ValoresClienteAdministrativoModel();
  precoLabel = "Vl. Total";
  loading = false;

  async atualizaValores() {
    let preco = 0;
    if (!this.valoresAdm.checkboxValorSaida) {
      preco -= this.valoresAdm?.valorSaida || 0;
    } 

    if ((this.valoresAdm?.valorHoraParada || 0) > 0) {
      if ((this.valoresAdm?.qtdHoraParada || 0) == 0) {
        this.valoresAdm.qtdHoraParada = 1;
      }
    }

    if ((this.valoresAdm?.valorHoraTrabalhada || 0) > 0) {
      if ((this.valoresAdm?.qtdHoraTrabalhada || 0) == 0) {
        this.valoresAdm.qtdHoraTrabalhada = 1;
      }
    }

    if ((this.valoresAdm?.valorPatins || 0) > 0) {
      if ((this.valoresAdm?.qtdPatins || 0) == 0) {
        this.valoresAdm.qtdPatins = 1;
      }
    }
    await assistencia24hModule
        .recalcularValorServico({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.valoresAdm.idCliente || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          preco = res;
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.openDialog(
            "error", 
            "Erro ao recalcular serviço", 
            "Tivemos problemas recalcular o valor do serviço. Tente novamente."
            );
        });

        this.valoresAdm.preco = preco
        this.dialogTitle = "Valor da Solicitação " + this.valoresAdm.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
  }

  verificaPossuiStep() {
    if (!this.possuiStep?.valor){
      this.closeDialog();
      this.openDialogStep( 
        "confirm",
        "Atenção" ,
        "Favor, fazer a escolha do  serviço de guincho.",
        ""
      );
      return;
    }
  }

  verificaCarregado() {
    if (this.carregado?.valor){
      this.closeDialog();
      this.openDialogStep( 
        "confirm",
        "Atenção" ,
        "Favor, fazer a escolha do serviço de guincho.",
        ""
      );
      return;
    }
  }

  @Watch("clienteAdministrativo")
  obterDadosClienteAdm(val: any) {
    this.isFrota = false;
    this.clienteAdm = false;
    this.enderecoClienteAdministrativo = new LocalidadeModel();
    if (val.frota) {
      this.isFrota = true;
    }

    if (val.id) {
      this.clienteAdm = true;
    }

    if (val.endereco) {
      this.enderecoClienteAdministrativo = val.endereco;
      this.enderecoClienteAdministrativo.tipoEndereco = this.tiposEnderecos.find(endereco => endereco.valor === val.endereco.tipo);
      this.enderecoClienteAdministrativo.estado = this.estados.find(estado => estado.sigla === val.endereco.estado);
    }
    
  }

  confirmarStep() { 
    this.$router.push({ name: "CadastroGuincho" });
  }  

  closeStep() { 
    window.location.reload()
  }  

  confirmar() {
    if (this.valoresAdm.frota) {
      this.confirmarFrota();
    } else {
      this.confirmarAdm();
    }
  }

  confirmarAdm() { 
    this.loadingFrota = true;
    assistencia24hModule
        .confirmarSolicitacaoAdm({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.valoresAdm.idCliente || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          this.closeDialog();
          this.loadingFrota = false;
          this.successDialog = true;
          this.openDialog(
            "success", 
            "Serviço solicitado com sucesso!", 
            "Acompanhe as solicitações através do menu Acompanhar Solicitações."
          );
          this.$router.push({ name: "HomePage" });
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.loadingFrota = false;
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            "Tivemos problemas na solicitação do serviço. Tente novamente."
            );
        });
  }

  confirmarFrota() { 
    this.loadingFrota = true;
    assistencia24hModule
        .confirmarSolicitacaoFrota({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.clienteAdministrativo.id || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          this.closeDialog();
          this.loadingFrota = false;
          this.successDialog = true;
          this.openDialog(
            "success", 
            "Serviço solicitado com sucesso!", 
            "Acompanhe as solicitações através do menu Acompanhar Solicitações."
          );
          this.$router.push({ name: "HomePage" });
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.loadingFrota = false;
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            "Tivemos problemas na solicitação do serviço. Tente novamente."
            );
        });
  }

  async resetStore() {
    await assistencia24hModule.RESET();
  }

  loadFromStore() {
    this.loadingData = true;
    const questionarioTrocaPneu = assistencia24hModule.questionarioTrocaPneu;
    this.veiculoEmLocalFechado = questionarioTrocaPneu?.veiculoEmLocalFechado || false;
    this.veiculoDoAssociado = questionarioTrocaPneu?.veiculoPertenceAoAssociado || true;
    this.veiculo = questionarioTrocaPneu?.veiculo || {
      placa: "",
      chassi: "",
      marca: "",
      modelo: "",
      anoFabricacao: "",
      anoModelo: "",
      cor: "",
      combustivel: "",
      cilindrada: "",
      tipoVeiculo: { valor: "", texto: "" },
    };
    this.enderecoSelecionado = questionarioTrocaPneu?.localizacao || new LocalidadeModel();
    this.nomeContatoNoLocal = questionarioTrocaPneu?.nomeContatoNoLocal || "";
    this.telefoneContatoNoLocal = questionarioTrocaPneu?.telefoneContatoNoLocal || "";
    this.veiculoEmSubsolo = questionarioTrocaPneu?.veiculoEmSubsolo || false;
    this.servicoSubClienteFrota = questionarioTrocaPneu?.servicoSubCliente || new ServicoSubClienteModel();
    this.enderecoServicoFrota.cep = questionarioTrocaPneu?.servicoSubCliente?.cep || "";
    this.clienteAdministrativo =
    questionarioTrocaPneu?.clienteAdministrativo || new ClienteAdministrativoModel();
      this.clienteAdministrativo.endereco!.cep = questionarioTrocaPneu?.clienteAdministrativo?.endereco?.cep || ""; 
    this.loadingData = false;
  }

  @Watch("veiculo.tipoVeiculo")
  avisoGuincho() {
    if (this.veiculo.tipoVeiculo?.valor === 'PESADO'  || this.veiculo.tipoVeiculo?.valor === 'ULTRA_PESADO') {
      this.exibirCancelar = false;
      this.closeDialog();
      this.openDialogStep( 
        "confirm",
        "Atenção" ,
        "Favor, fazer a escolha do  serviço de guincho.",
        ""
      );
    }
  }

  @Watch("veiculoDoAssociado")
  habilitaCamposContato(val: boolean) {
    if (!this.loadingData && val) {
      this.nomeContatoNoLocal = "";
      this.telefoneContatoNoLocal = "";
    }
  }

  @Watch("veiculoEmLocalFechado")
  permiteSubsolo(val: boolean) {
    if (!this.loadingData && val) {
      this.veiculoEmSubsolo = false;
    }
  }

  solicitarPrecificacao() {
    this.$refs.trocaPneuObserver.validate().then((valid: boolean) => {
      if (!valid) {
        this.openDialog(
          "information", 
          "Dados incompletos", 
          "Preencha todos os campos obrigatórios para continuar com a solicitação do serviço."
        );
        return;
      }

      if (valid) {

      if (!this.possuiStep?.valor) {
        this.verificaPossuiStep();
        return;
      }
      this.loading = true;      
      if (this.enderecoServicoFrota) {
        this.servicoSubClienteFrota.cep = this.enderecoServicoFrota.cep;
        this.servicoSubClienteFrota.tipoEndereco = this.enderecoServicoFrota.tipoEndereco; 
        this.servicoSubClienteFrota.logradouro = this.enderecoServicoFrota.logradouro; 
        this.servicoSubClienteFrota.numero = this.enderecoServicoFrota.numero;
        this.servicoSubClienteFrota.complemento = this.enderecoServicoFrota.complemento || ""; 
        this.servicoSubClienteFrota.bairro = this.enderecoServicoFrota.bairro; 
        this.servicoSubClienteFrota.cidade = this.enderecoServicoFrota.cidade; 
        this.servicoSubClienteFrota.estado = this.enderecoServicoFrota.estado; 
      }

      if (this.enderecoClienteAdministrativo) {
        this.clienteAdministrativo.endereco = this.enderecoClienteAdministrativo;
      }

      const questionarioTrocaPneu = new QuestionarioTrocaPneuModel(this.veiculoDoAssociado, this.veiculo, this.enderecoSelecionado, this.veiculoEmLocalFechado, this.veiculoEmSubsolo, this.nomeContatoNoLocal, this.telefoneContatoNoLocal, this.servicoSubClienteFrota, this.possuiFerramenta?.valor,this.clienteAdministrativo);
      assistencia24hModule.SET_QUESTIONARIO_TROCA_PNEU(questionarioTrocaPneu);

      assistencia24hModule
        .solicitarPrecificacaoTrocaPneu()
        .then((res: any) => {
          if (assistencia24hModule.precificacao) {
            const precificacao = assistencia24hModule.precificacao as Record<string, any>;
            this.valoresAdm = {
                valorTotalAdicional: precificacao.valorTotalAdicional ?? 0,
                valorHoraParada: precificacao.valorHoraParada ?? 0,
                valorPatins: precificacao.valorPatins ?? 0,
                valorHoraTrabalhada: precificacao.valorHoraTrabalhada ?? 0,
                valorPedagio: precificacao.valorPedagio ?? 0,
                valorPrestador: precificacao.valorPrestador ?? 0,
                valorGuinchoPesado: precificacao.valorGuinchoPesado ?? 0,
                valorOperadora: precificacao.valorOperadora ?? 0,
                valorComissaoCorretor: precificacao.valorComissaoCorretor ?? 0,
                valorAgravo: precificacao.valorAgravo ?? 0,
                valorDesconto: precificacao.valorDesconto ?? 0,
                idCliente: precificacao.idCliente,
                frota: precificacao.frota ?? false,
                preco: precificacao?.preco ?? 0,
                valorSaida: precificacao?.valorSaida ?? 0,
                valorExcedente: precificacao?.valorExcedente ?? 0,
                qtdKmExcedente: precificacao?.qtdKmExcedente ?? 0,
                checkboxValorSaida: true,
                qtdPatins: 0,
                qtdHoraTrabalhada: 0,
                qtdHoraParada: 0,
                kmTotal: precificacao?.kmTotal?? 0
            };

            this.valoresPrecificado = {
                valorTotalAdicional: precificacao.valorTotalAdicional ?? 0,
                valorHoraParada: precificacao.valorHoraParada ?? 0,
                valorPatins: precificacao.valorPatins ?? 0,
                valorHoraTrabalhada: precificacao.valorHoraTrabalhada ?? 0,
                valorPedagio: precificacao.valorPedagio ?? 0,
                valorPrestador: precificacao.valorPrestador ?? 0,
                valorGuinchoPesado: precificacao.valorGuinchoPesado ?? 0,
                valorOperadora: precificacao.valorOperadora ?? 0,
                valorComissaoCorretor: precificacao.valorComissaoCorretor ?? 0,
                valorAgravo: precificacao.valorAgravo ?? 0,
                valorDesconto: precificacao.valorDesconto ?? 0,
                idCliente: precificacao.idCliente,
                frota: precificacao.frota ?? false,
                preco: precificacao?.preco ?? 0,
                valorSaida: precificacao?.valorSaida ?? 0,
                valorExcedente: precificacao?.valorExcedente ?? 0,
                qtdKmExcedente: precificacao?.qtdKmExcedente ?? 0,
                checkboxValorSaida: true,
                qtdPatins: 0,
                qtdHoraTrabalhada: 0,
                qtdHoraParada: 0,
                kmTotal: precificacao?.kmTotal?? 0
            };
          };
          
          
          if (assistencia24hModule.precificacao?.frota && assistencia24hModule.precificacao?.faturamento) {
            this.closeDialog();
            this.openDialogCliente( 
              "confirm",
              "Valor da Solicitação " + assistencia24hModule.precificacao?.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) ,
              "O Pagamento acontecerá no fechamento da sua fatura com os descontos negociados.",
              "Acompanhe as solicitações através do menu Acompanhar Solicitações."
            );
          // this.$router.push({ name: "HomePage" });
          } else {
            this.openDialogCliente( 
              "confirm",
              "Valor da Solicitação " + assistencia24hModule.precificacao?.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) ,
              "",
              ""
            );
          }
          this.loading = false;
        })
        .catch((err: any) => {
          this.loading = false;
          console.error(err);
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            err.message
          );
        });
      }
    });
    this.loading = false;
  }

  closeDialog() {
    this.showDialog = false;
    this.dialogMessage = "";
    this.dialogMessageAux = "";
    this.showDialogFrota = false;
    this.showDialogStep = false;
    this.showDialogAdm = false;
    this.loading = false;
    if (this.successDialog) {
      this.$router.push({ name: "MinhasSolicitacoes" });
    }
    this.successDialog = false;
  }

  private openDialogFrota(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogFrota = true;
  }

  private openDialogCliente(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogAdm = true;
  }

  private openDialogStep(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogStep = true;
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

  fecharMessageDialog() {
    this.messageDialog = false;
    this.message = "";
  }
}
